import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppTheme } from './theme/AppTheme'
import { AuthProvider } from './auth/AuthProvider'
import App from './App'

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false }, mutations: { retry: 0 } } })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppTheme><QueryClientProvider client={queryClient}><BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter></QueryClientProvider></AppTheme>
  </StrictMode>,
)
